<template>
    <div class="column is-one-third">
        <div class="card">
            
            <div class="card-content">
                <div class="has-text-centered">
                    <img :src="logo" style="max-width:50%;" alt="logo-empresa">
                </div>
                    <label>Nueva clave</label>
                    <div class="field">
                        <p class="control has-icons-left">
                            <input 
                            type="password"
                            v-model="keySet.newPassword"
                            class="input is-rounded is-light" 
                            style="border:0.8px solid var(--primary)">
                            <span class="icon is-small is-left">
                                <i class="fas fa-lock"></i>
                            </span>
                        </p>
                    </div>
                    
                    <label>Vuelve a ingresar la nueva clave</label>
                    <div class="field">
                        <p class="control has-icons-left">
                            <input 
                            type="password"
                            v-model="keySet.newPassword2"
                            class="input is-rounded is-light" 
                            style="border:0.8px solid var(--primary)">
                            <span class="icon is-small is-left">
                                <i class="fas fa-lock"></i>
                            </span>
                        </p>
                    </div>

                    <b-field>
                        <VueRecaptcha @verify="verifyCaptcha" sitekey="6LcHavwUAAAAAGnN37OSgSLR7e9XfivBHo7xGRwd"/>
                    </b-field>

                    <div class="has-text-centered">
                        <b-button 
                        rounded
                        style="background:var(--primary); color:var(--text-color)"
                        @click="sendNewKeys"
                        :disabled="disabledBtn"
                        :loading="loading">
                            Resetear clave
                            <span class="m-l-10 icon is-small">
                                <i class="fas fa-paper-plane"></i>
                            </span>
                        </b-button>
                    </div>
            </div>
            
        </div>
        <div class="has-text-centered m-t-20">
            <a href="https://traction.cloud" class="has-text-dark">
                Powered by 
            <img src="../../../assets/logo.png" style="max-height:18px; vertical-align:centered;" alt="traction-logo">
            </a>
        </div>
    </div>
</template>

<script>
import { postHandler } from '../../../services/http';
import VueRecaptcha from "vue-recaptcha";

export default {
    components:{
        VueRecaptcha
    },
    props:{
        logo:{
            type:String,
            default:""
        },
        resetUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            keySet:{
                newPassword:"",
                newPassword2:""
            },
            loading:false,
            captchaToken:""
        }
    },
    methods:{
        async sendNewKeys(){
            let success={
                resource:"notify",
                text:"Clave reestablecida cone exito!"
            }
            let error={
                resource:"notify",
                text:"Parece que las claves no coinciden"
            }
            this.loading = true
            this.keySet['captchaToken'] = this.captchaToken
            let res = await postHandler(this.resetUrl, this.keySet, {error, success})
            this.loading = false
            if (res.status==200){
                window.location.href = '/user/login/'
            }
        },
        verifyCaptcha(token){
            this.captchaToken=token
            this.disabledBtn
        }
    },
    computed:{
        disabledBtn(){
            if (!this.captchaToken.length || !this.keySet.newPassword.length || !this.keySet.newPassword2){
                return true 
            }
            return false
        }
    }
}
</script>